













































import { Component, Emit, Mixins, Prop, Vue, Watch } from 'vue-property-decorator';
import Button from '../../../core/components/Button.vue';
import { RootStoreHelper, NotificationStoreHelper, VehicleStoreHelper, CompanyStoreHelper, AuthStoreHelper, StoreHelper } from '../../../core/mixins';
@Component({
    components: {
      Button
    }
})
export default class ChatbotMsgFeedbackText extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
  visible: boolean = true;
  comment: string = '';
  
  @Emit()
  closeModal() {}

  @Emit()
  sentComment(comment: string) {}

  get formIsValid() {
    return this.comment.length > 0;
  }

  
   
}
